import React, { useEffect, useState } from 'react';
import { Button as Oldbutton, Popover } from 'antd';
import classNames from 'classnames';
import styles from './starred-reports-button.module.scss';
import { StarOutlineIcon } from 'components/assets/Icons/Icons';
import { StarredReportsDialog } from './starred-reports-dialog/starred-reports-dialog';
import { useStarReportActions } from 'store/star-report/use-star-report-actions';
import { Dropdown, IconButton } from '@placer-ui/components';
import { getFeatureFlags } from 'core/flow-control';

const TOOLTIP_ALIGN = {
    offset: [0, -3],
};

export const StarredReportsButtonDeprecated = () => {
    const [isDialogVisible, onSetIsDialogVisible] = useState(false);
    const { getReports } = useStarReportActions();
    const { accessibility_starred_reports_ff, enable_pi_in_the_platform } = getFeatureFlags();

    const btnClassNames = classNames(styles.starredReportsButton, {
        [styles.addTriggerActive]: isDialogVisible,
    });
    const iconClassName = classNames({
        [styles.starActive]: isDialogVisible,
        [styles.starInactive]: !isDialogVisible,
    });

    const onClosePopover = () => {
        onSetIsDialogVisible(false);
    };

    const onVisibleChange = () => {
        onSetIsDialogVisible(!isDialogVisible);
    };

    useEffect(() => {
        getReports();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {accessibility_starred_reports_ff ? (
                <Dropdown
                    testId="starred-reports-dropdown"
                    hasPointer
                    trigger={
                        <IconButton
                            testId="starred-reports-button"
                            size="small"
                            variant="ghost"
                            aria-label="starred reports"
                            Icon={<StarOutlineIcon className={iconClassName} />}
                        />
                    }
                >
                    <StarredReportsDialog onClose={onClosePopover} />
                </Dropdown>
            ) : (
                <Popover
                    content={<StarredReportsDialog onClose={onClosePopover} />}
                    trigger="click"
                    placement={enable_pi_in_the_platform ? 'bottomRight' : 'bottom'}
                    destroyTooltipOnHide
                    visible={isDialogVisible}
                    autoAdjustOverflow={false}
                    onVisibleChange={onVisibleChange}
                    overlayClassName={styles.starredReportsOverlay}
                    align={TOOLTIP_ALIGN}
                >
                    <div className={btnClassNames}>
                        <Oldbutton icon={<StarOutlineIcon className={iconClassName} />} />
                    </div>
                </Popover>
            )}
        </>
    );
};
